<template lang="pug">
  v-dialog(v-model='dialogCalculadora' scrollable max-width='100%' persistent)
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline Complemento Operativo
      v-card-text
        v-row(dense class='d-flex justify-center')
          v-card-subtitle.title(style='color: black') Ordenes
            v-btn.mx-2(v-if="read === false" fab width='17%' height= '70%' dark small color='success' @click='enterOrdenesAux()')
              v-icon(dark='') mdi-plus
          table(border='0' width='100%' align='center')
            tr(style="border: 1px solid grey;")
              td(align="center")
                div
                  span.bold(style='color: black') Proveedor
              td(align="center")
                div
                  span.bold(style='color: black') Descripción de Mercancía
              td(align="center")
                div
                  span.bold(style='color: black') Peso(Kg)
              td(align="center")
                div
                  span.bold(style='color: black') Cubicaje(ft³)
              td(align="center")
                div
                  span.bold(style='color: black') Piezas
              td(align="center")
                div
                  span.bold(style='color: black') Sub Total FOB($)
              td(align="center")
            tr(v-for="(ord, k) in ordenesAux" :key="k" align='center')
              td.inputTamanno
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.proveedor')
              td.inputTamanno
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.descripcion')
              td.inputTamanno2
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.peso' type='number' min="0" @change="changePeso")
              td.inputTamanno2
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.cubicaje' type='number' min="0" @change="changeCubicaje")
              td.inputTamanno2
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.piezas' type='number' min="0" @change="changePiezas")
              td.inputTamanno2
                v-text-field(style='font-size: 13px; margin-bottom: -25px;' :readonly='read' dense outlined v-model='ord.subTotalFob' type='number' min="0" @change="changeSubTotalFob")
              td.inputDelete(v-if="read === false")
                v-icon(color='error' @click="deleteRowOrdenesAux(k, ord)") mdi-delete
            tr
              td
              td.inputTamanno3
                b.letra TOTALES:
              td.inputTamanno2
                v-text-field.size(dense outlined readonly v-model='tPeso')
              td.inputTamanno2
                v-text-field.size(dense outlined readonly v-model='tCubicaje')
              td.inputTamanno2
                v-text-field.size(dense outlined readonly v-model='tPiezas')
              td.inputTamanno2
                v-text-field.size(dense outlined readonly v-model='tSubTotalFob')
      v-card-actions
        v-btn(color='error' small style='width: 10%' dark @click='closeCalculadora')
          v-icon mdi-close
          | Salir
        v-btn(v-if="mostrar" color='error' small style='width: 10%' dark @click='finalizarCalculadora')
          v-icon mdi-delete
          | Finalizar
        v-spacer
        v-btn(v-if="read === false" color='success' small style='width: 10%' dark @click='saveCalculadora')
          v-icon mdi-content-save
          | Guardar
</template>
<script>
import { EventBus } from '../../Events'
export default {
  props: ['dialogCalculadora'],
  name: 'Calculadora',
  data: () => ({
    read: false,
    ordenesAux: [],
    tPeso: 0,
    tCubicaje: 0,
    tPiezas: 0,
    tSubTotalFob: 0,
    tamanno: 0,
    mostrar: false,
  }),

  created () {
    EventBus.$on('dataCalculadora', data => {
      console.log('LLEGO A CALCULADORA', data)
      if (data.condicion === 'cond1') {
        for (let i = 0; i < data.ordenes2.length; i++) {
          this.ordenesAux.push({
            proveedor: data.ordenes2[i].proveedorOrd.nombre,
            descripcion: data.ordenes2[i].descripcionProdOrd,
            peso: parseFloat(data.ordenes2[i].kilogramosOrd),
            cubicaje: parseFloat(data.ordenes2[i].piesCubicosOrd),
            piezas: parseFloat(data.ordenes2[i].piezasOrd),
            subTotalFob: parseFloat(data.ordenes2[i].totalOrd)
          });
          this.tPeso = data.peso
          this.tCubicaje = data.cubicaje
          this.tPiezas = data.piezas
          this.tSubTotalFob = data.sub
        }
      } else {
        this.ordenesAux = data.calculadora.ordenes2
        this.tPeso = data.calculadora.peso
        this.tCubicaje = data.calculadora.cubicaje
        this.tPiezas = data.calculadora.piezas
        this.tSubTotalFob = data.calculadora.sub
        this.mostrar = true
      }
      this.tamanno = this.ordenesAux.length
      this.read = data.read
    })
  },

  methods: {
    changePeso () {
      this.tPeso = 0
      let acumPeso = 0
      for (let i = 0; i < this.ordenesAux.length; i++) {
        if (this.ordenesAux[i].peso > 0) {
          acumPeso += parseFloat(this.ordenesAux[i].peso)
        }
      }
      this.tPeso = acumPeso
      this.tPeso = (this.tPeso).toFixed(2)
    },

    changeCubicaje () {
      this.tCubicaje = 0
      let acumCubicaje = 0
      for (let i = 0; i < this.ordenesAux.length; i++) {
        if (this.ordenesAux[i].cubicaje > 0) {
          acumCubicaje += parseFloat(this.ordenesAux[i].cubicaje)
        }
      }
      this.tCubicaje = acumCubicaje
      this.tCubicaje = (this.tCubicaje).toFixed(2)
    },

    changePiezas () {
      this.tPiezas = 0
      let acumPiezas = 0
      for (let i = 0; i < this.ordenesAux.length; i++) {
        if (this.ordenesAux[i].piezas > 0) {
          acumPiezas += parseFloat(this.ordenesAux[i].piezas)
        }
      }
      this.tPiezas = acumPiezas
      this.tPiezas = (this.tPiezas).toFixed(2)
    },

    changeSubTotalFob () {
      this.tSubTotalFob = 0
      let acumSub = 0
      for (let i = 0; i < this.ordenesAux.length; i++) {
        if (this.ordenesAux[i].subTotalFob > 0) {
          acumSub += parseFloat(this.ordenesAux[i].subTotalFob)
        }
      }
      this.tSubTotalFob = acumSub
      this.tSubTotalFob = (this.tSubTotalFob).toFixed(2)
    },

    enterOrdenesAux () {
      this.ordenesAux.push({
        proveedor: '',
        descripcion: '',
        peso: 0,
        cubicaje: 0,
        piezas: 0,
        subTotalFob: 0
      });
    },

    deleteRowOrdenesAux(index, row) {
      var idx = this.ordenesAux.indexOf(row);
      if (idx > -1) {
        this.ordenesAux.splice(idx, 1);
      }
      this.changePeso()
      this.changeCubicaje()
      this.changePiezas()
      this.changeSubTotalFob()
    },

    closeCalculadora () {
      this.ordenesAux = []
      this.tPeso = 0,
      this.tCubicaje = 0,
      this.tPiezas = 0,
      this.tSubTotalFob = 0,
      this.tamanno = 0
      this.mostrar = false
      this.$emit('closeCalculadora')
    },

    finalizarCalculadora () {
      this.ordenesAux = []
      this.tPeso = 0,
      this.tCubicaje = 0,
      this.tPiezas = 0,
      this.tSubTotalFob = 0,
      this.tamanno = 0
      this.mostrar = false
      this.$emit('finalizarCalculadora', this.ordenesAux)
    },
    
    saveCalculadora () {
      if (this.tamanno !== this.ordenesAux.length) {
        let array = { // PASARLE PASEFLOAT A MONTOS
          ordenes2: this.ordenesAux,
          peso: this.tPeso,
          cubicaje: this.tCubicaje,
          piezas: this.tPiezas,
          sub: this.tSubTotalFob
        }
        this.ordenesAux = []
        this.$emit('saveCalculadora', array)
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'No ha agregado ningun complemento'
        })
      }
    }
  }
}
</script>
<style lang="scss">
  .inputTamanno {
    padding: 0px 1px 20px 0px;
    width: 30%;
  }
  .inputTamanno2 {
    padding: 0px 1px 20px 0px;
  }
  .inputDelete {
    padding: 0px 0px 35px 0px;
  }
  .inputTamanno3 {
    padding: 0px 10px 40px 0px;
    text-align: right
  }
  .text {
    font-size: 13px;
    margin-bottom: -13px;
  }
  .bold {
    font-weight: bold;
  }
</style>